import React from "react";

export function SellerAdminUserDetail() {
  return <div>Seller Admin User Detail</div>;
}
